import * as React from "react";
import { Formik, Form } from "formik";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import GranteesSelectorFormGroup from "./GranteesSelectorFormGroup";
const FormElements = styled.div`
  display: flex;
`;
const Errors = styled.div(
  ({ theme }) => css`
    width: 100%;
    margin-top: 3px;
    color: ${theme.colors.variant.danger};

    > * {
      margin-right: 5px;

      &:last-child {
        margin-right: 0;
      }
    }
  `
);
const SubmitButton = styled(Button)`
  margin-left: 15px;
`;
const _initialCapabilityId = (capabilities) => {
  var _a;
  const initialCapabilityTitle = "Viewer";
  return (_a = capabilities.find((capability) => capability.title === initialCapabilityTitle)) == null ? void 0 : _a.id;
};
const GranteesSelector = ({
  availableGrantees,
  availableCapabilities,
  className = null,
  onSubmit,
  formRef = null
}) => {
  const initialCapabilityId = _initialCapabilityId(availableCapabilities);
  const _handelSubmit = (data, resetForm) => {
    onSubmit(data).then(() => {
      resetForm();
    });
  };
  return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: (data, { resetForm }) => _handelSubmit(data, resetForm),
      innerRef: formRef,
      initialValues: { granteeId: void 0, capabilityId: initialCapabilityId }
    },
    ({ isSubmitting, isValid, errors }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(FormElements, null, /* @__PURE__ */ React.createElement(
      GranteesSelectorFormGroup,
      {
        availableGrantees,
        availableCapabilities
      }
    ), /* @__PURE__ */ React.createElement(
      SubmitButton,
      {
        bsStyle: "primary",
        disabled: isSubmitting || !isValid,
        title: "Add Collaborator",
        type: "submit"
      },
      "Add Collaborator"
    )), errors && /* @__PURE__ */ React.createElement(Errors, null, Object.entries(errors).map(([fieldKey, value]) => /* @__PURE__ */ React.createElement("span", { key: fieldKey }, String(value), "."))))
  ));
};
export default GranteesSelector;
